package game.entity

import game.Game
import game.Room

class ArrowTrap : Enemy() {
    private var throwing = false
    private var coolDown = 0
    private val arrow = Projectile(0.3, 1, 1, false) {
        throwing = false
    }

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("arrow-trap")
    }

    override fun onTick(game: Game, room: Room) {
        if (coolDown > 0) {
            coolDown--
        }
        else if (!throwing) {
            val player = game.player
            when {
                player.col == col && player.row < row ->
                    startThrow(game, player.col, player.row, "arrow-up")

                player.col == col && player.row > row ->
                    startThrow(game, player.col, player.row, "arrow-down")

                player.row == row && player.col < col ->
                    startThrow(game, player.col, player.row, "arrow-left")

                player.row == row && player.col > col ->
                    startThrow(game, player.col, player.row, "arrow-right")
            }

        }
    }

    private fun startThrow(game: Game, targetCol: Int, targetRow: Int, spriteId: String) {
        arrow.startAttack(game, col, row, targetCol, targetRow, spriteId)
        game.currentRoom.addEntity(arrow)
        throwing = true
        coolDown = 50
    }
}